import React, { useEffect, useState } from "react";

import { tw } from "@careinfo/tailwind";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  createAccount,
  createAccountInfovalidation,
} from "../../../../validation/AccountInfo";
import Button from "../../../Reusable/Button";
import AccountInfoForm from "./AccountInfoForm";

const CreateAccountPopup = (props: any) => {
  const { handleCreateAccount, isLoading, setOpenAccountPopup } = props;
  const [isactive, setIsActive] = useState("credit");
  const {
    control,
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm<any>({
    resolver: yupResolver(createAccount),
    defaultValues: {
      parent: {
        id: "21ae21a9-4b3d-4850-b06a-da41422a52be",
        account_full_name: "Assets-Current Assets-Cash",
      },
    },
  });
  useEffect(() => {
    setValue("balance_type", isactive);
  }, [isactive]);

  return (
    <form
      onSubmit={handleSubmit((data) =>
        handleCreateAccount(data, setOpenAccountPopup, setError)
      )}
      className={tw`max-w-2xl`}
      autoComplete="off"
    >
      <AccountInfoForm
        control={control}
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
        isactive={isactive}
        setIsActive={setIsActive}
      />
      <div className={tw`mt-4 w-full px-4 `}>
        <div className={tw`w-32 ml-auto`}>
          <Button label="Create" isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
};

export default CreateAccountPopup;
